export default __webpack_public_path__ + "static/media/background.f68e5756.png";